import React, { useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Paper, IconButton, Chip
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Edit, Delete, ArrowDropDown } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import moment from 'moment/moment';
import { useDispatch } from 'react-redux';
import DeleteModal from '../reusable/deleteModal/DeleteModal';
import CatPagination from '../reusable/catPagination/CatPagination';
import { useNavigate } from 'react-router-dom';
import Operations from '../reusable/Operations';
import { fomateDate } from '../../utils/fomateDate';
import { deleteCategoriesThunk, setEditCategory } from '../../redux/category/getAllCategorySlice';
import { deleteorderThunk } from '../../redux/orderSlice';

// Styled components using MUI's `styled` API
const TableContainerStyled = styled(TableContainer)(({ theme }) => ({
  borderRadius: 8,
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  border: '1px solid #E0E2E7',
}));

const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: '#f8f9fa',
  color: '#495057',
  padding: '6px 0px 0px 20px',
  fontFamily: `'Public Sans', sans-serif !important`,

}));

const TableCells = styled(TableCell)(({ theme }) => ({
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const ActionIcons = styled(TableCell)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  paddingLeft: '6px',
  borderBottom: '1px solid rgba(224, 224, 224, 1)',
}));

const ProductText = styled(TableCell)(({ theme }) => ({
  color: '#495057',
  fontWeight: 'bold',
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const New = styled(Chip)(({ theme }) => ({
  backgroundColor: '#4A4C561A',
  color: '#4A4C56',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Processing = styled(Chip)(({ theme }) => ({
  backgroundColor: '#FFF0EA',
  color: '#F86624',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));


const Pending = styled(Chip)(({ theme }) => ({
  backgroundColor: '#FFF0EA',
  color: 'orange',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Cancelled = styled(Chip)(({ theme }) => ({
  backgroundColor: '#FFF0EA',
  color: 'red',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Shiped = styled(Chip)(({ theme }) => ({
  backgroundColor: '#EAF8FF',
  color: '#2BB2FE',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Delivered = styled(Chip)(({ theme }) => ({
  backgroundColor: '#E9FAF7',
  color: '#1A9882',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));


const AllOrderTable = ({ ordersData, page, setPage, itemsPerPage, start, end, totalItems, handleOpenMenu }) => {


  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [selectedId, setSelectedId] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false);

  //delete
  const deleteCategory = () => {
    dispatch(deleteorderThunk(selectedId))
    setIsModalOpen(false);

  }


  //delete modal open
  const handleDeleteClick = (id) => {
    setIsModalOpen(true);
    setSelectedId(id)
  };





  return (
    <>
      <TableContainerStyled component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <HeaderCell>
                Order ID
                <IconButton onClick={(e) => handleOpenMenu('_id')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Products
                <IconButton onClick={(e) => handleOpenMenu('product')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Date
                <IconButton onClick={(e) => handleOpenMenu('date')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Customer
                <IconButton onClick={(e) => handleOpenMenu('name')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Total
                <IconButton onClick={(e) => handleOpenMenu('total')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              {/* <HeaderCell>
                Payment
                <IconButton onClick={(e) => handleOpenMenu(e, 'Category')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell> */}

              <HeaderCell>
                Status
                <IconButton onClick={(e) => handleOpenMenu('status')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Action
              </HeaderCell>
            </TableRow>

          </TableHead>

          <TableBody >
            {ordersData.map((row) => (
              <TableRow key={row._id}>

                <ProductText sx={{ width: '13%',maxWidth:120,textOverflow:'ellipsis',overflow:'hidden' }}>{row._id}</ProductText>

                <TableCells sx={{
                  width: '15%',

                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {/* <div>
                      {
                        row?.products?.length > 0 ?

                          row?.products[0]?.productDetails?.assets?.featuredImage[0] ?
                            <img src={row?.products[0]?.productDetails?.assets?.featuredImage[0]} style={{ width: 44, height: 44, borderRadius: 2 }} />
                            :
                            <img src="/assets/profile.png" />

                          : null}
                    </div> */}
                       <div style={{ maxWidth: 130, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      <strong style={{ color: '#1D1F2C' }}>{row?.products[0]?.productDetails?.productOverview?.productNumber[0]}</strong>
                      {row?.products?.length > 1 ?
                        <div style={{ fontSize: '14px', color: '#667085', fontWeight: '500', }}>
                          +{row?.products?.length - 1} other products
                        </div>
                        : null}
                    </div>
                  </div>
                </TableCells>

                <ProductText sx={{ width: '13%' }}>{fomateDate(row.createdAt)}</ProductText>


                <TableCells sx={{
                  width: '15%',

                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div>
                      <strong style={{ color: '#1D1F2C' }}>{row?.user?.fullName}</strong>
                      <div style={{ fontSize: '14px', color: '#667085', fontWeight: '500',maxWidth: 130, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                   
                        {row?.user?.email}
                      </div>
                    </div>
                  </div>
                </TableCells>

                <TableCells sx={{ width: '13%', fontSize: '14px', color: '#667085', fontWeight: '500' }}>
                  {row?.priceBreakup?.total?.toFixed(2)}
                </TableCells>

                {/* <TableCells sx={{ width: '13%', fontSize: '14px', color: '#667085', fontWeight: '500' }}>
                  {fomateDate(row.createdAt)} 
                </TableCells> */}


                <TableCells sx={{ width: '13%' }}>
                  {row?.status === "NEW" ? (
                    <New label="New" size="small" />
                  ) : row?.status === "DELIVERED" ? (
                    <Delivered label="Delivered" size="small" />
                  ) : row?.status === "PENDING" ? (
                    <Pending label="Pending" size="small" />
                  ) : row?.status === "PROCESSING" ? (
                    <Processing label="Processing" size="small" />
                  ) : row?.status === "CANCELLED" ? (
                    <Cancelled label="Cancelled" size="small" />
                  ) : (
                    <Shiped label="shipped" size="small" />
                  )}
                </TableCells>


                <Operations
                  TableCells={TableCells}
                  viewClick={() => navigate(`/orders/orderDetails/${row?._id}`)}
                  deleteClick={() => handleDeleteClick(row?._id)}
                  selectedTab={1}
                />

                <DeleteModal
                  isOpen={isModalOpen}
                  heading={'Order'}
                  onClose={() => setIsModalOpen(false)}
                  onDelete={deleteCategory}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div>
          <CatPagination
            start={start}
            end={end}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            setPage={setPage}
            page={page}
          />
        </div>
      </TableContainerStyled>

    </>
  );
};

export default AllOrderTable;
